var _path, _path2, _path3, _polygon, _path4, _polygon2, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle2, _circle3, _circle4, _circle5, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeather(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 903.81496,
    height: 419,
    viewBox: "0 0 903.81496 419",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1002.29825,657.63462c-7.66862-.31841-14.65546-3.4134-17.8161-8.20809q-.22188-.3366-.41782-.68273c-1.15407-2.04287-1.5142-4.39169-.2526-6.40454s4.41342-3.54208,7.5786-3.22463,5.63632,2.842,4.32649,4.84032c-.29278-4.03819-.53206-8.28109,2.72379-11.79607a11.8971,11.8971,0,0,1,6.665-3.44471c6.56018-1.15377,10.91609,2.5554,11.78838,6.30113.64385,2.76482-.24562,5.57713-1.13059,8.31052,2.72833-3.22649,9.21772-4.662,14.18726-3.13827s7.72721,5.7944,6.02891,9.3367c-2.00047,4.17253-8.66851,6.32973-14.8625,7.46953C1016.00221,657.935,1008.33266,657.88517,1002.29825,657.63462Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#a8edea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M735.29825,657.63462c-7.66862-.31841-14.65546-3.4134-17.8161-8.20809q-.22188-.3366-.41782-.68273c-1.15407-2.04287-1.5142-4.39169-.2526-6.40454s4.41342-3.54208,7.5786-3.22463,5.63632,2.842,4.32649,4.84032c-.29278-4.03819-.53206-8.28109,2.72379-11.79607a11.8971,11.8971,0,0,1,6.665-3.44471c6.56018-1.15377,10.91609,2.5554,11.78838,6.30113.64385,2.76482-.24562,5.57713-1.13059,8.31052,2.72833-3.22649,9.21772-4.662,14.18726-3.13827s7.72721,5.7944,6.02891,9.3367c-2.00047,4.17253-8.66851,6.32973-14.8625,7.46953C749.00221,657.935,741.33266,657.88517,735.29825,657.63462Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#a8edea"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M489.59229,417h-55a16.51867,16.51867,0,0,1-16.5-16.5v-103a16.51867,16.51867,0,0,1,16.5-16.5h55a16.51868,16.51868,0,0,1,16.5,16.5v103A16.51868,16.51868,0,0,1,489.59229,417Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "679.306 406.177 667.047 406.177 661.214 358.889 679.308 358.89 679.306 406.177",
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M830.52529,658.56159l-39.53052-.00147v-.5a15.38605,15.38605,0,0,1,15.38648-15.38623h.001l24.1438.001Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "816.262 394.707 804.705 398.799 783.42 356.172 800.476 350.132 816.262 394.707",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M971.269,645.3652l-37.26281,13.19639-.16693-.47131a15.38606,15.38606,0,0,1,9.36673-19.64037l.00092-.00033,22.7588-8.05979Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M827.05741,630.80006a4.61332,4.61332,0,0,1-.82031-.07421l-14.99194-2.72559a4.52108,4.52108,0,0,1-3.69751-4.33691c-2.1792-100.91407,8.53467-168.72852,31.8435-217.33594a4.47342,4.47342,0,0,1,4.69092-2.48145l53.91162,7.78321a4.50521,4.50521,0,0,1,3.82788,3.94726l4.75391,41.90332a3.54563,3.54563,0,0,0,.14185.666l51.68921,154.86914a4.5194,4.5194,0,0,1-2.866,5.63086L941.57206,623.302a4.52335,4.52335,0,0,1-5.44824-2.25684L866.20561,489.20827a1.50017,1.50017,0,0,0-2.80689.34961L831.43754,627.263A4.48168,4.48168,0,0,1,827.05741,630.80006Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M784.44969,324.5973a10.52739,10.52739,0,0,1,.2393,1.64013l42.95745,24.782,10.44141-6.01094L849.219,359.58076,831.76867,372.0183a8,8,0,0,1-9.59819-.23384L777.874,336.83863a10.4971,10.4971,0,1,1,6.57573-12.24133Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M828.23667,348.54228a4.49518,4.49518,0,0,1,2.21126-3.025l19.713-11.02278a12.49741,12.49741,0,0,1,15.32664,19.74413l-15.71732,16.32122a4.5,4.5,0,0,1-6.80392-.37268l-13.88374-17.994A4.495,4.495,0,0,1,828.23667,348.54228Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#FBD8E4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 726.04977,
    cy: 57.06582,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M898.05864,416.86842a4.49986,4.49986,0,0,1-.728-.05957L844.17729,408.095a4.49988,4.49988,0,0,1-3.67407-5.374l2.58593-12.1914c-1.32373-1.97461-12.10254-19.14551,1.02564-35.27442a22.01039,22.01039,0,0,1,20.43335-22.92187l27.46924-2.08692a22.12706,22.12706,0,0,1,23.02172,27.88477l-12.593,55.2373A4.51031,4.51031,0,0,1,898.05864,416.86842Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#FBD8E4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M947.6947,463.05847a10.74272,10.74272,0,0,0-4.27021-15.90952L913.161,354.10209l-17.53839,8.322,33.11316,90.59865a10.80091,10.80091,0,0,0,18.95894,10.03573Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M919.855,369.59337l-23.28842,7.035a4.81687,4.81687,0,0,1-6.15823-3.90862l-3.5355-23.995A13.37737,13.37737,0,0,1,912.507,341.063l10.31233,21.866a4.81689,4.81689,0,0,1-2.96431,6.66438Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#FBD8E4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M850.26787,298.51445a30.44348,30.44348,0,0,0,32.21073-6.76432c-2.57623,6.80639-1.856,35.674-1.856,35.674s22.84668-10.84668,25.94629-12.74359c18.30713-11.20417-6.9419-59.94287-27.94629-52.25641-3.55762,1.30188-6.529,2.83372-7.96807,6.33788-3.13633-3.86875-9.07321-4.70786-13.63995-2.72072s-7.81312,6.29343-9.55868,10.95785a27.4066,27.4066,0,0,0,1.993,23.11342Z",
    transform: "translate(-148.09252 -240.5)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M743.09252,240.5h-562a33.03244,33.03244,0,0,0-33,33v154a33.03244,33.03244,0,0,0,33,33h562a33.03244,33.03244,0,0,0,33-33v-154A33.03244,33.03244,0,0,0,743.09252,240.5Zm31,187a31.03964,31.03964,0,0,1-31,31h-562a31.03964,31.03964,0,0,1-31-31v-154a31.03964,31.03964,0,0,1,31-31h562a31.03964,31.03964,0,0,1,31,31Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M236.84252,386a12,12,0,1,1,12-12A12.01375,12.01375,0,0,1,236.84252,386Zm0-22a10,10,0,1,0,10,10A10.0113,10.0113,0,0,0,236.84252,364Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M236.44872,359a1,1,0,0,1-1-1V346.5a1,1,0,0,1,2,0V358A1,1,0,0,1,236.44872,359Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M220.84252,374.60645h-11.5a1,1,0,0,1,0-2h11.5a1,1,0,1,1,0,2Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M262.84252,374.60645h-11.5a1,1,0,0,1,0-2h11.5a1,1,0,0,1,0,2Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M251.0266,363.67236a1,1,0,0,1-.69629-1.71777l4.81592-4.67236a1,1,0,0,1,1.39258,1.43554l-4.81592,4.67237A.99626.99626,0,0,1,251.0266,363.67236Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M221.65844,363.67236a.99668.99668,0,0,1-.69629-.28222l-4.81592-4.67237a1,1,0,1,1,1.39258-1.43554l4.81592,4.67236a1,1,0,0,1-.69629,1.71777Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M217.84252,391a1.00025,1.00025,0,0,1-.71753-1.69678l4.81592-4.95947a1.00017,1.00017,0,0,1,1.43506,1.39355l-4.81592,4.95948A.99855.99855,0,0,1,217.84252,391Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M256.84252,392a.995.995,0,0,1-.71558-.30176l-5.81591-5.95947a.99979.99979,0,1,1,1.43115-1.39648l5.81592,5.95947A.99975.99975,0,0,1,256.84252,392Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M236.44872,402a1,1,0,0,1-1-1V389.5a1,1,0,0,1,2,0V401A1,1,0,0,1,236.44872,402Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M367.25609,393H333.87426a13.00186,13.00186,0,0,1,0-26h2.553a15.70676,15.70676,0,0,1,14.13794-9,15.866,15.866,0,0,1,15.697,15h.99389a10.00136,10.00136,0,0,1,0,20Zm-33.38183-24a11.00221,11.00221,0,0,0,0,22h33.38183a8.00171,8.00171,0,0,0,0-16h-1.96362a1,1,0,0,1-1-1,13.88125,13.88125,0,0,0-13.72729-14,13.72466,13.72466,0,0,0-12.57471,8.39453,1.00022,1.00022,0,0,1-.91895.60547Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M478.76391,374.05664l-.7793-1.8418A10.002,10.002,0,1,0,464.84423,359.188l-1.84863-.7627a12.0019,12.0019,0,1,1,15.76831,15.63135Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M480.25609,393H446.87426a13.00186,13.00186,0,0,1,0-26h2.553a15.70676,15.70676,0,0,1,14.13794-9,15.866,15.866,0,0,1,15.697,15h.99389a10.00136,10.00136,0,0,1,0,20Zm-33.38183-24a11.00221,11.00221,0,0,0,0,22h33.38183a8.00171,8.00171,0,0,0,0-16h-1.96362a1,1,0,0,1-1-1,13.88125,13.88125,0,0,0-13.72729-14,13.72466,13.72466,0,0,0-12.57471,8.39453,1.00022,1.00022,0,0,1-.91895.60547Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M593.25609,388h-4.01391a1,1,0,0,1,0-2h4.01391a8.00171,8.00171,0,0,0,0-16h-1.96362a1,1,0,0,1-1-1,13.88125,13.88125,0,0,0-13.72729-14,13.72466,13.72466,0,0,0-12.57471,8.39453,1.00022,1.00022,0,0,1-.91895.60547h-3.19726a11.00221,11.00221,0,0,0,0,22h3.1001a1,1,0,0,1,0,2h-3.1001a13.00186,13.00186,0,0,1,0-26h2.553a15.70676,15.70676,0,0,1,14.13794-9,15.866,15.866,0,0,1,15.697,15h.99389a10.00136,10.00136,0,0,1,0,20Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M576.39965,392.31689a1,1,0,0,1-1-1v-11.5a1,1,0,1,1,2,0v11.5A1.00005,1.00005,0,0,1,576.39965,392.31689Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M569.39965,398.31689a1,1,0,0,1-1-1v-11.5a1,1,0,1,1,2,0v11.5A1.00005,1.00005,0,0,1,569.39965,398.31689Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M583.39965,401.31689a1,1,0,0,1-1-1v-11.5a1,1,0,1,1,2,0v11.5A1.00005,1.00005,0,0,1,583.39965,401.31689Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M706.25609,388h-4.01391a1,1,0,0,1,0-2h4.01391a8.00171,8.00171,0,0,0,0-16h-1.96362a1,1,0,0,1-1-1,13.88125,13.88125,0,0,0-13.72729-14,13.72466,13.72466,0,0,0-12.57471,8.39453,1.00022,1.00022,0,0,1-.91895.60547h-3.19726a11.00221,11.00221,0,0,0,0,22h3.1001a1,1,0,1,1,0,2h-3.1001a13.00186,13.00186,0,0,1,0-26h2.553a15.70676,15.70676,0,0,1,14.13794-9,15.866,15.866,0,0,1,15.697,15h.99389a10.00136,10.00136,0,0,1,0,20Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 539.75,
    cy: 142.75,
    r: 2.25,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 547.25,
    cy: 145.75,
    r: 2.25,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 534.75,
    cy: 149.25,
    r: 2.25,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 542.75,
    cy: 154.25,
    r: 2.25,
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M265.09252,312h-58a8,8,0,0,1,0-16h58a8,8,0,0,1,0,16Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#FBD8E4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M378.09252,312h-58a8,8,0,1,1,0-16h58a8,8,0,0,1,0,16Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#FBD8E4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M491.09252,312h-58a8,8,0,1,1,0-16h58a8,8,0,0,1,0,16Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#FBD8E4"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M604.09252,312h-58a8,8,0,0,1,0-16h58a8,8,0,0,1,0,16Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#FBD8E4"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M717.09252,312h-58a8,8,0,0,1,0-16h58a8,8,0,0,1,0,16Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#FBD8E4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M290.09252,406a1,1,0,0,1-1-1V329a1,1,0,0,1,2,0v76A1,1,0,0,1,290.09252,406Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#e6e6e6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M403.09252,405a1,1,0,0,1-1-1V328a1,1,0,0,1,2,0v76A1,1,0,0,1,403.09252,405Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#e6e6e6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M522.09252,405a1,1,0,0,1-1-1V328a1,1,0,0,1,2,0v76A1,1,0,0,1,522.09252,405Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#e6e6e6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M635.09252,405a1,1,0,0,1-1-1V328a1,1,0,0,1,2,0v76A1,1,0,0,1,635.09252,405Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#e6e6e6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1050.90748,659.5h-381a1,1,0,1,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-148.09252 -240.5)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.74fa541d684c029f5e8316e871246561.svg";
export { ForwardRef as ReactComponent };